import { FunctionComponent, useEffect, useState } from 'react';
import { Table, DropdownMultiselect, OptionListOption, Icon, Input } from '@gaiads/telia-react-component-library';
import { UserRole } from '@cdaas/api-clients/dist/asset-user-openapi';

import { User } from '../../types';
import { useTranslation } from 'react-i18next';

interface GroupsUsersRowProps {
  user: User;
  userGroupRightsOptions: UserRole[];
  handleDropdownInputChange: (userId: string, right: UserRole) => void;
  handleDeleteUser: (userId: string) => void;
  handleChangeUserEmail: (userId: string, email: string) => void;
  hideDeleteIcon: boolean;
}

const GroupsUsersRow: FunctionComponent<GroupsUsersRowProps> = (props: GroupsUsersRowProps) => {
  const { t: tGlobal } = useTranslation('globalComponents');

  const [options, setOptions] = useState<OptionListOption[]>([]);

  useEffect(() => {
    const userGroupRightsDropdownOptions = props.userGroupRightsOptions.map(ur => {
      const option = { label: tGlobal(`userRoles.${ur}`), value: ur, checked: false, disabled: false };
      if (props.user.user_roles.user_group.includes(ur)) {
        option.checked = true;
        option.disabled = true;
      } else if (props.user.user_roles.user.includes(ur)) {
        option.checked = true;
      }
      option.disabled = true; // !!! This will disable selection in MVP, remove it allow select user's roiles !!!
      return option;
    });
    setOptions(userGroupRightsDropdownOptions);
  }, [tGlobal, props.user, props.userGroupRightsOptions]);

  return (
    <Table.Row>
      <Table.Cell>
        {props.user.newItem ? (
          <Input showCustomLabel onChange={e => props.handleChangeUserEmail(props.user.id!, e.target.value)} value={props.user.email} label="" />
        ) : props.user.name ? (
          props.user.name
        ) : (
          props.user.email
        )}
      </Table.Cell>
      <Table.Cell>{props.user.phone_number}</Table.Cell>
      <Table.Cell>
        <DropdownMultiselect
          showCustomLabel={true}
          onChange={(_event, option) => props.handleDropdownInputChange(props.user.id!, option.value as UserRole)}
          onClear={() => {}}
          options={options}
        />
      </Table.Cell>
      {!props.hideDeleteIcon && (
        <Table.Cell>
          <Icon name="delete" size="md" clickableAppearance onClick={() => props.handleDeleteUser(props.user.id!)} />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default GroupsUsersRow;
